import { render } from "./Hotspot9.vue?vue&type=template&id=3b53a125&scoped=true&ts=true"
import script from "./Hotspot9.vue?vue&type=script&lang=ts"
export * from "./Hotspot9.vue?vue&type=script&lang=ts"

import "./Hotspot9.vue?vue&type=style&index=0&id=3b53a125&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b53a125"]])

export default __exports__